// extracted by mini-css-extract-plugin
module.exports = {"metric":"styles_metric__rW56V","label":"styles_label__a_S4J","bar":"styles_bar__tRTY9","meter":"styles_meter__oKjzN"};